import script from "./CreateCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCourses.vue?vue&type=script&setup=true&lang=js"

import "./CreateCourses.vue?vue&type=style&index=0&id=7c477c5f&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c477c5f"]])

export default __exports__